import { GatewayService } from '../GatewayService';
import { AppSession } from '../AppSession';
import { PhicubeResponse } from '../interface/PhicubeResponse';
import { AppStorage } from '../AppStorage';

export class ContratoProvider {
    apiListaContratosPorUsuario(): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/user/contratos2')
    }

    listaContratosPorUsuario(): Promise<any> {
        return AppStorage.get(AppSession.CHAVE_CONTRATO_USUARIO)
    }
}